exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".open-folder[data-v-65401252] {\n  display: flex;\n  overflow: hidden;\n}\n.open-folder.showLink[data-v-65401252] {\n  cursor: pointer;\n}\n.open-folder .folder-icon[data-v-65401252] {\n  width: 24px;\n  min-width: 24px;\n  height: 18px;\n  min-height: 18px;\n  margin-right: 3px;\n}\n.oh-ellipsis[data-v-65401252] {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n", ""]);

// exports
